<div class="payment-modal">
  <div mat-dialog-content>
    <div class="main-title mt-0 mb-0">
      <h5>{{data.name ? data.name : 'Create'}} Payment</h5>
    </div>

    <button (click)="cancel()" class="close" data-dismiss="modal" type="button">&times;</button>
  </div>

  <form *ngIf="formGroup" [formGroup]="formGroup">
    <mat-tab-group #tabgroup (selectedTabChange)="updateStripe()">
      <mat-tab label="General">
        <div class="input-wrap general-tab">
          <label class="full-width" for="journal">Payment Method</label>
          <mat-radio-group (change)="updateJournalevent($event)" [(ngModel)]="selectedJournal" formControlName="journal"
                           id="journal">
            <mat-radio-button *ngFor="let journal of journals" [name]="journal.name" [value]="journal.id">
              <span>{{journal.name}}</span>
              <div class="payment-method-icon">
                <img src="{{journal.icon}}">
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="input-wrap input-mat-select">
          <label>Invoices <span class="required-symbol">*</span></label>
          <app-portal-select
            formControlName="invoice"
            [items]="invoices"
            [withFilter]="true"
            [required]="true"
            placeholder="Invoices"
            itemId="id"
            itemName="number"
            (selectionChange)=updateAmount($event)>
            <ng-template let-item #option>
              {{item?.number}}
            </ng-template>
          </app-portal-select>
        </div>
        <div *ngIf="invoiceResidual" class="input-wrap">
          <label>Residual
            amount: {{currencySymbolBefore}}{{invoiceResidual | number:'1.2-2'}}{{currencySymbolAfter}}</label>
        </div>
        <div class="input-wrap">
          <label for="amount">Amount to pay <span class="required-symbol">*</span></label>
          <input appInputTrimmer (change)="updateAmountToPay()" formControlName="amount" id="amount"
                 type="text">
          <span *ngIf="tooltipService.getState('amount')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('amount', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Amount to pay'">
              </app-tooltip>
            </span>
        </div>
        <div *ngIf="isBankTransfer" class="input-wrap">
          <label for="ref">Reference <span class="required-symbol">*</span></label>
          <input appInputTrimmer formControlName="ref" id="ref" type="text">
          <span *ngIf="tooltipService.getState('ref')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('ref', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Reference'">
              </app-tooltip>
            </span>
        </div>
        <div class="input-wrap description-total">
          <label for="description">Description</label>
          <app-char-counter-textarea
            id="description"
            [textValue]="this.charChange"
            [maxNumberOfCharacters]="1000"
            ngDefaultControl
            placeholderText="Description"
            [formControl]="formGroup.get('description')"
            (valueChange)="onTextareaValueChanged($event)">
          </app-char-counter-textarea>
          <span *ngIf="tooltipService.getState('description')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('description', defaultRequired, defaultExists, invalidDesc)"
                [position]="'below'"
                [fieldName]="'Description'">
              </app-tooltip>
            </span>
        </div>
        <div *ngIf="totalAmountToPay" class="total-payment-amount">
          <h5>Total: <span>${{totalAmountToPay}}</span></h5>
          <hr>
        </div>
        <span *ngIf="invoiceDraftPayment"
              class="invoice-draft-payment"> Existing draft payment for invoice {{invoiceDraftPayment.name}}</span>

        <div class="general-tab-buttons pb-2">
          <button (click)="cancel()" class="btn-cancel" mat-button>Cancel</button>

          <button (click)="createOrUpdatePayment()" *ngIf="!isStripe  && data.state === 'DRAFT' && !invoiceDraftPayment"
                  [disabled]="isDisabled" class="ml-2 create-btn"
                  color="primary"
                  mat-flat-button>{{data.name ? data.name : 'Create'}}
          </button>

          <button (click)="stripeCheckout()" *ngIf="isStripe  && data.state === 'DRAFT' && !invoiceDraftPayment"
                  class="ml-2"
                  color="primary"
                  mat-flat-button>Checkout
          </button>
        </div>
      </mat-tab>

      <mat-tab *ngIf="isStripe" label="Checkout">
        <app-stripe-card-list (selected)="stripeGuestToken($event)" [events]="eventsSubject.asObservable()"
                              [guestCheckout]="guestCheckout"></app-stripe-card-list>
        <div *ngIf="totalAmountToPay" class="total-payment-amount">
          <h5>Total: <span>${{totalAmountToPay | number:'1.2-2'}}</span></h5>
          <hr>
        </div>

        <div *ngIf="!data.guestCheckout" class="checkout-buttons">
          <button (click)="cancel()" class="btn-cancel" mat-button>Cancel</button>

          <button (click)="createStripePayment()" *ngIf="isStripe  && data.state === 'DRAFT' && !invoiceDraftPayment"
                  [disabled]="isDisabled"
                  class="btn-pay" color="primary"
                  mat-flat-button>Pay
          </button>
        </div>

        <div *ngIf="data.guestCheckout" class="checkout-buttons">
          <button (click)="cancel()" class="btn-cancel mr-2" mat-button>Cancel</button>

          <button (click)="createStripePayment()" *ngIf="!invoiceDraftPayment" [disabled]="!stripeCardToken"
                  class="btn-pay" color="primary"
                  mat-flat-button>Pay
          </button>
        </div>
        <span *ngIf="invoiceDraftPayment"
              class="invoice-draft-payment">Existing draft payment for invoice {{invoiceDraftPayment.name}}</span>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>

